import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FAFAF8] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#0F172A] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Role-based redirect
  if (role === "admin" && user.role !== "admin") {
    return <Navigate to={user.role === "council_member" ? "/council" : "/dashboard"} replace />;
  }
  if (role === "council_member" && user.role !== "council_member" && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  if (role === "explorer" && user.role === "admin") {
    return <Navigate to="/admin" replace />;
  }
  if (role === "explorer" && user.role === "council_member") {
    return <Navigate to="/council" replace />;
  }

  return children;
}
